import { createAction, props } from '@ngrx/store';

import { EntityTypeDetailsFragment, RestrictedExportingSettingTypeDetailsFragment } from 'generated/graphql';

export const SET_CURRENT_CAMPAIGN = createAction(
  '[CampaignContext] Set Current Campaign',
  props<
    {
      payload: {
        id: string;
        name: string;
        defaultEntityType: EntityTypeDetailsFragment;
        showCustomIds: boolean;
        showElectoralDistricts: boolean;
        allowOrganizersToExport?: boolean;
        activityStreamAsInitialEntityView?: boolean;
        restrictedExportingSettings: RestrictedExportingSettingTypeDetailsFragment;
        entityConnectionTypes?: Array<{ id: string }>;
      };
    }
  >()
);

export const CAMPAIGN_ID_CHANGED = createAction('[ROOT: Campaign Id Changed]', props<{ campaignId: string }>());
